import { render, staticRenderFns } from "./ReassignPosts.vue?vue&type=template&id=1a6fe8fe&"
import script from "./ReassignPosts.vue?vue&type=script&lang=ts&"
export * from "./ReassignPosts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports